import { DI } from '@intigral/constant/config/DIContainer';
import { container } from '../../../DataDomain';
import { IEntitlementRepository } from '../../repositories/interfaces/iEntitlementRepository';

export interface IAllowedCountriesUseCase {
    execute(apiKey: string): Promise<any>;
}

export class AllowedCountriesUseCase implements IAllowedCountriesUseCase {
    // Lazy getter for repository to avoid circular dependencies
    private get allowedCountriesRepository(): IEntitlementRepository {
        return container.resolve<IEntitlementRepository>(DI.REPOSITORIES.IEntitlementRepository);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }
    async execute(apiKey: string): Promise<any> {
        const response = await this.allowedCountriesRepository.allowedCountries(apiKey);
        return response.data;
    }
}
